import React, { useState, useContext, useEffect } from 'react'
import "./searchItems.css"
import { AiFillCloseCircle } from "react-icons/ai";
import { BsFillSearchHeartFill } from "react-icons/bs";
import RestaurentContext from '../../../../context/rest_context';
import FoodItem from '../../../../components/food-item/FoodItem';

const SearchItemPage = ({ showSearch, setShowSearch }) => {

  const { restItems } = useContext(RestaurentContext);
  const [filterItems, setFilterItems] = useState([]);

  useEffect(() => {
    setFilterItems(restItems);
  }, [restItems])



  if (!showSearch) {
    return null
  }



  const handleInput = (event) => {
    const search = event.target.value;
    const items = restItems.filter((item) =>
      item.name.toLowerCase().includes(search.toLowerCase())
    );

    // Remove duplicates based on dbID
    const uniqueItems = Array.from(new Map(items.map(item => [item.dbID, item])).values());

    console.log(uniqueItems);
    setFilterItems(uniqueItems);
  }

  return (
    <div className='search-items-page-bg !z-[1000]' >
      <div className='search-item-page-container'>
        <div className='search-icon'>
          <h3> Search </h3>
          <span onClick={() => setShowSearch(false)} > <AiFillCloseCircle /></span>
        </div>
        <div className='search-box'>
          <span><BsFillSearchHeartFill /></span>
          <input
            type="text"
            placeholder='search for dishes...'
            onChange={handleInput}
          />
        </div>
        {
          filterItems.length !== 0 &&
          <div className='search-results-container !z-[10000]' >
            {
              filterItems.map((item, index) => {
                console.log(JSON.stringify(item), index);
                return <FoodItem key={index} item={item} isLast={filterItems.length - 1 === index} />
              })
            }
          </div>

        }

      </div>
    </div>
  )
}

export default SearchItemPage


